<template>
  <div class="layout-vertical-center">
    <el-card style="min-width: 552px;">
      <template #header>{{ $t('login.title') }}</template>
      <div style="margin-bottom: 42px;">
        {{ $t('login.dont_have_account') }}
        <router-link to="/signup">
          {{ $t('login.clickhere') }}
        </router-link>
      </div>
      <el-form
        ref="refForm"
        :model="formData"
        :rules="rules"
        label-position="top"
        @keyup.enter="doLogin"
        @submit.prevent>
        <el-form-item :label="$t('login.email')" prop="email">
          <el-input v-model="formData.email" />
        </el-form-item>
        <el-form-item :label="$t('login.password')" prop="password">
          <el-input v-model="formData.password" :type="passwordInput ? 'password' : 'text'">
            <template #append>
              <div role="button" class="pointer" @click="passwordInput = !passwordInput">
                <i :class="passwordInput ? 'bi bi-eye-slash' : 'bi bi-eye'"></i>
              </div>
            </template>
          </el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            :loading="loading"
            type="primary"
            class="btn-full-block"
            @click="doLogin">
            {{ $t('login.signin') }}
          </el-button>
        </el-form-item>
      </el-form>
      <router-link to="/forget-password">
        <div class="text-center"> {{ $t('login.forgotpass') }} </div>
      </router-link>
    </el-card>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useStore } from 'vuex'
import { useRouter } from 'vue-router'
import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const store = useStore()
const router = useRouter()
const loading = ref(false)
const refForm = ref(null)
const formData = reactive({
  password: '',
  email: ''
})
const passwordInput = ref(true)
const rules = reactive({
  password: [{ required: true, trigger: 'blur' }],
  email: [{ required: true, type: 'email', trigger: 'blur' }]
})

const doLogin = () => {
  if (!refForm.value) return
  refForm.value.validate((valid) => {
    if (valid) {
      loading.value = true
      store.dispatch('app/fetchClientToken', formData).then((response) => {
        store.dispatch('app/getAccountInfo')
        router.push({
          path: '/documentation/introduction'
        })
        loading.value = false
      }).catch((error) => {
        if (error.string === 'auth.not_verified') {
          router.push({
            path: '/verification',
            query: { email: formData.email }
          })
          ElMessage({
            type: 'error',
            message: t('login.not_verified')
          })
        } else {
          ElMessage({
            type: 'error',
            message: error.string
          })
        }
        loading.value = false
      })
    } else {
      ElMessage({
        type: 'warning',
        message: t('warning.complete_the_data')
      })
      loading.value = false
      return false
    }
  })
}
</script>
